// components/ImageWithFallback.jsx
'use client';

import NextImage from 'next/image';
import { useState } from 'react';

const FALLBACK = '/images/products/placeholder.png';

export default function Image({ src, ...props }) {
  const [imgSrc, setImgSrc] = useState(
    (src !== 'null' && !!src && src) || FALLBACK
  );

  return (
    <NextImage
      {...props}
      src={imgSrc}
      onError={() => setImgSrc(FALLBACK)}
    />
  );
}